export default __webpack_public_path__ + "static/media/16.72b9883e.png";